import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import ContactForm from '@/pages/about/components/ContactForm';

const VALUES = [
  { icon: 'ri-book-open-line', title: '内容详实', desc: '每部作品均提供完整剧情梗概与演员资料，帮助快速了解故事脉络。' },
  { icon: 'ri-layout-grid-line', title: '查找高效', desc: '多维筛选与清晰分类，让你用最短时间定位想看的情感题材作品。' },
  { icon: 'ri-newspaper-line', title: '资讯及时', desc: '持续整理行业动态、剧情解析与作品评论，紧跟影视资讯节奏。' },
];

const SCOPE = [
  { label: '电影', to: '/category?category=电影' },
  { label: '电视剧', to: '/category?category=电视剧' },
  { label: '爱情题材', to: '/category?genre=爱情' },
  { label: '悬疑题材', to: '/category?genre=悬疑' },
  { label: '伦理剧情', to: '/category?genre=伦理' },
  { label: '都市情感', to: '/category?genre=都市' },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 - 奸情影视大全"
        description="了解奸情影视大全的网站定位与内容范围：专注情感纠葛题材电影与电视剧的剧情介绍、演员信息与影视资讯，并提供联系方式。"
        keywords="关于我们,奸情影视,影视大全,联系方式,网站介绍"
      />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
          <nav className="mb-5 flex items-center gap-2 text-xs text-foreground-500 md:text-sm" aria-label="面包屑导航">
            <Link to="/" className="transition-colors hover:text-foreground-950">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-950">关于我们</span>
          </nav>
          <span className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-primary-400">
            About Us
          </span>
          <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于奸情影视大全
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            “奸情影视大全”是一个专注情感纠葛题材的内容门户，致力于为影迷提供全面的剧情介绍、演员信息与最新影视资讯，
            让每一位用户都能便捷地了解并深入查找自己感兴趣的作品。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <section className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">网站定位</h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700">
              我们围绕“情感纠葛”这一题材，系统整理电影与电视剧作品。每一部作品都会提供剧情梗概、基本资料、演员阵容与相关推荐，
              帮助你从不同维度了解故事内容。网站面向所有对这类题材感兴趣的普通观众与影视文化爱好者。
            </p>
            <p className="mt-3 text-sm leading-loose text-foreground-700">
              需要说明的是，本站所有内容均以影视介绍为目的，<strong className="text-foreground-950">不提供影片播放与下载功能</strong>，
              页面展示的数据均为演示示例，用于呈现网站的浏览与查找体验。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {VALUES.map((v) => (
              <div key={v.title} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{v.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-14">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">内容范围</h2>
          <p className="mt-3 text-sm text-foreground-600">覆盖多种情感题材与作品类型，可按需进入对应分类浏览。</p>
          <div className="mt-5 flex flex-wrap gap-3">
            {SCOPE.map((s) => (
              <Link
                key={s.label}
                to={s.to}
                className="whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-500 hover:text-foreground-950"
              >
                {s.label}
              </Link>
            ))}
          </div>
        </section>

        <section className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.4fr] lg:items-start">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">联系我们</h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700">
              如果你对网站内容有建议，或希望补充某部作品的信息、投稿影视资讯，欢迎通过下方表单留言，
              我们会认真查看每一条反馈。
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm">
              <p className="flex items-center gap-3 text-foreground-800">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                  <i className="ri-mail-line"></i>
                </span>
                contact@jianqing-demo.example
              </p>
              <p className="flex items-center gap-3 text-foreground-800">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                  <i className="ri-time-line"></i>
                </span>
                我们通常在 1-2 个工作日内回复
              </p>
            </div>
          </div>

          <ContactForm />
        </section>
      </div>
    </>
  );
}